import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import type { RoutesFunc } from 'src/routes/routes';

import { ProfiledApp } from './app';

export function loadReactApp(routes: RoutesFunc) {
  const root = document.getElementById('react-root');
  if (!root) {
    throw new Error('react-root element not found');
  }
  const reactRoot = createRoot(root);
  reactRoot.render(
    <StrictMode>
      <ProfiledApp routes={routes} />
    </StrictMode>,
  );
}
